"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorInfo = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ErrorInfo = ({
  title,
  description,
  buttonTitle,
  handleButtonClick
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.ERROR_INFO),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ErrorCircle, {
        fontSize: "inherit",
        color: "inherit"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "h4",
      component: "h4",
      color: "inherit",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      color: "inherit",
      textAlign: "center",
      children: description
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ButtonContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        fullWidth: true,
        color: "primary",
        variant: "contained",
        id: "accept",
        onClick: handleButtonClick,
        children: buttonTitle
      }, "accept")
    })]
  });
};
exports.ErrorInfo = ErrorInfo;
